import type { CSSProperties } from 'react'

import { cx } from '@/libs/cva'

type SkeletonProps = {
  className?: string
  style?: CSSProperties
}

export const Skeleton = ({ className, style }: SkeletonProps) => {
  return (
    <div
      aria-hidden
      className={cx('h-3 w-3 animate-pulse rounded-[4px] bg-ui-bg-component', className)}
      style={style}
    />
  )
}
